export function formatISODateString(isoString: string, minutes = true): string {
    // Create a Date object from the ISO 8601 string
    const date = new Date(isoString);

    // Define options for how you want the date/time formatted
    if (!minutes) {
        const options = {
            year: "numeric" as const,
            month: "long" as const,
            day: "numeric" as const,
            hour12: true, // Use 12-hour clock
        };
        return date.toLocaleString("en-US", options);
    }
    const options = {
        year: "numeric" as const,
        month: "long" as const,
        day: "numeric" as const,
        hour: "numeric" as const,
        minute: "2-digit" as const,
        second: "2-digit" as const,
        hour12: true, // Use 12-hour clock
    };

    // Convert to a locale string using the options above
    return date.toLocaleString("en-US", options);
}
